import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Dedicated admin login page at /admin.
 * Not linked anywhere in the public UI — reachable only by typing the URL.
 * The actual access control is server-side (ADMIN_PASSWORD + JWT); this page
 * is just the entry point.
 */
const AdminLoginPage: React.FC = () => {
  const { isAdmin, login, logout } = useAuth();
  const { t } = useScript();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useDocumentTitle(t('Администрација'), '/admin');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const ok = await login(password);
    setLoading(false);
    setPassword('');
    if (ok) {
      navigate('/');
    } else {
      setError(t('Погрешна лозинка'));
    }
  };

  return (
    <div className="site-mode-page">
      <div
        className="site-mode-bg"
        style={{
          backgroundImage:
            'linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.7)), url(/resource/slika.jpg)',
        }}
      />

      <div className="site-mode-content">
        <div className="site-mode-cross">{'☦'}</div>
        <h1 className="site-mode-title">{t('Манастир Градац')}</h1>
        <div className="site-mode-divider" />
        <h2 className="site-mode-heading">{t('Администрација')}</h2>

        {isAdmin ? (
          <>
            <p className="site-mode-message">{t('Пријављени сте као администратор.')}</p>
            <div className="site-mode-login-actions" style={{ justifyContent: 'center' }}>
              <button type="button" onClick={() => navigate('/')}>
                {t('Иди на сајт')}
              </button>
              <button type="button" onClick={() => logout()}>
                {t('Одјави се')}
              </button>
            </div>
          </>
        ) : (
          <form className="site-mode-login-form" onSubmit={handleLogin}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('Лозинка')}
              aria-label={t('Лозинка')}
              autoFocus
              disabled={loading}
            />
            {error && <div className="site-mode-login-error">{error}</div>}
            <div className="site-mode-login-actions">
              <button type="submit" disabled={loading}>
                {loading ? t('Пријава...') : t('Пријави се')}
              </button>
            </div>
          </form>
        )}

        <div className="site-mode-admin-section">
          <Link to="/" className="site-mode-admin-toggle">
            {t('Назад на почетну')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
